import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const NAV_LINKS = [
  { href: '#services', label: 'Servicios' },
  { href: '#coverage', label: 'Cobertura' },
  { href: '#about', label: 'Nosotros' },
  { href: '#app', label: 'App' },
  { href: '#clients', label: 'Clientes' },
  { href: '#contact', label: 'Contacto' },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={cn(
        'safe-top fixed inset-x-0 top-0 z-40 transition-colors duration-300',
        scrolled
          ? 'border-b border-white/[0.04] bg-[#060B16]/95 backdrop-blur-xl'
          : 'bg-transparent',
      )}
    >
      <div className="container flex h-16 items-center justify-between">
        <a href="#top" className="flex items-center gap-2 font-bold">
          <img src="/logo_visep_192.webp" alt="" className="h-9 w-9 object-contain" aria-hidden />
          <span className="text-lg">VISEP</span>
        </a>

        <nav aria-label="Principal" className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-slate-400 transition-colors hover:text-white"
            >
              {link.label}
            </a>
          ))}
          {scrolled && (
            <Button
              size="sm"
              className="h-10 rounded-full px-5 text-sm font-semibold"
              asChild
            >
              <a href="#quotation">Cotizar</a>
            </Button>
          )}
          <Button
            size="sm"
            variant="ghost"
            className="h-10 rounded-full border border-white/10 px-5 text-sm font-medium text-slate-300 transition-all hover:border-white/20 hover:bg-white/[0.03] hover:text-white"
            asChild
          >
            <a href="/app">Ingresar</a>
          </Button>
        </nav>

        <div className="flex items-center gap-2 lg:hidden">
          {scrolled && (
            <Button size="sm" className="h-9 rounded-full px-4 text-xs font-semibold" asChild>
              <a href="#quotation">Cotizar</a>
            </Button>
          )}
          <button
            type="button"
            className="min-touch-target inline-flex items-center justify-center"
            aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((o) => !o)}
          >
            {menuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav
          aria-label="Principal móvil"
          className="border-b border-white/[0.04] bg-[#060B16]/95 px-4 pb-4 backdrop-blur-xl lg:hidden"
        >
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block min-touch-target rounded-xl px-3 py-2 text-slate-400 hover:bg-white/[0.03] hover:text-white"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <Button
                className="mt-2 w-full rounded-full border border-white/10 text-slate-300 hover:border-white/20 hover:bg-white/[0.03] hover:text-white"
                variant="ghost"
                asChild
              >
                <a href="/app">Ingresar</a>
              </Button>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
